module.exports = __webpack_public_path__ + "static/media/schedule-meeting.80c198c3.png";